/*eslint-disable */

import { useState, useEffect, useContext } from 'react';
import ListHeader from '../SectionHeader';
import TablePagination from '../TablePaginationComponent';
import useFetchData from '../../hooks/useFetchData';
import useSort from '../../hooks/useSort';
import { ReactComponent as SortIcon } from '../../assets/images/sort.svg';
import Filter from '../Filter';
import { useNavigate } from 'react-router-dom';
import GlobalContext from 'contexts';

import globalTranslating from '../../translate.json';
import ClientTranslate from './translate.json';
import ExcelDownload from 'components/ExcelDownload';
// import '../style.scss';

const AnalysisBloodTests = () => {
  const navigate = useNavigate();
  const translating = { ...globalTranslating, ...ClientTranslate };
  const [filteredclients, setFilteredclients] = useState([]);
  const { data: clientsData, loading } = useFetchData(
    'client-product/dashboard/geneticAnalysisBloodTests'
  );
  let { data: bloodParamData } = useFetchData('blood-param');
  console.log('bbbb', bloodParamData);
  const { productsList } = useContext(GlobalContext);

  useEffect(() => {
    if (clientsData?.length) setFilteredclients(clientsData);
  }, [clientsData]);

  const onFilter = (filteredData) => {
    setFilteredclients(filteredData);
  };

  const onResetFilters = () => {
    setFilteredclients(clientsData);
  };

  const { showFilters, toggle } = useSort();

  const actionsclientsList = [
    {
      icon: SortIcon,
      txt: translating.edit,
      handleClickAction: () => {
        showFilters && setFilteredclients(clientsData);
        toggle(!showFilters);
      }
    }
  ];

  const tableHeaders = [
    translating.clientId,
    translating.fullName,
    translating.barcode,
    translating.ssn,
    translating.createdDate
  ];

  bloodParamData?.forEach((element) => {
    tableHeaders.push(element.name);
  });

  const [columns, setColumns] = useState([
    { value: 'id' },
    { value: 'clientFullName', sort: true, bold: true },
    { value: 'barcode' },
    { value: 'ssn' },
    { value: 'createdAt', format: 'date' }
  ]);

  useEffect(() => {
    const newColumns = [...columns];
    bloodParamData?.forEach((element) => {
      newColumns.push({ value: element.name });
    });
    setColumns(newColumns);
  }, [bloodParamData]);

  // const sortFields = [
  //   {
  //     type: 'search',
  //     label: translating.search,
  //     placeholder: translating.type3Dots,
  //     name: 'search',
  //     fields: ['clientFullName', 'ssn', 'mobile']
  //   },
  //   {
  //     type: 'select',
  //     label: translating.product,
  //     name: 'productId',
  //     options: productsList,
  //     isId: true
  //   },
  //   {
  //     type: 'date',
  //     subType: 'fromDate',
  //     label: translating.fromDate,
  //     name: 'fromDate',
  //     field: 'productCreated'
  //   },
  //   {
  //     type: 'date',
  //     subType: 'toDate',
  //     label: translating.toDate,
  //     name: 'toDate',
  //     field: 'productCreated'
  //   }
  // ];

  // const fields = [
  //   {
  //     type: 'select',
  //     label: translating.product,
  //     name: 'productId',
  //     options: productsList,
  //     isId: true
  //   },
  //   // {
  //   //   type: 'select',
  //   //   label: translating.statusProduct,
  //   //   name: 'statusId',
  //   //   options: currentSteppersData,
  //   //   isId: true
  //   // },
  //   {
  //     type: 'date',
  //     subType: 'fromDate',
  //     label: translating.fromDate,
  //     name: 'fromDate',
  //     field: 'createdAt'
  //   },
  //   {
  //     type: 'date',
  //     subType: 'toDate',
  //     label: translating.toDate,
  //     name: 'toDate',
  //     field: 'createdAt'
  //   },
  //   {
  //     type: 'autocomplete',
  //     label: translating.client,
  //     name: 'clientId',
  //     options: currentClientsData,
  //     searchBy: 'full_name'
  //   },
  //   {
  //     type: 'select',
  //     label: translating.organization,
  //     name: 'orgId',
  //     options: organizationsList,
  //     isId: true
  //   }
  // ];

  return (
    <div className="customers-list">
      <ListHeader
        title={translating.analysisBloodTests}
        actions={actionsclientsList}
      ></ListHeader>
      {/* {showFilters && productsList && (
        <Filter
          fields={sortFields}
          data={clientsData}
          handleFilter={onFilter}
          handleReset={onResetFilters}
        ></Filter>
      )} */}
      <div className="customers-list-wrapper-table">
        {loading && <div>Loading</div>}
        {filteredclients?.length ? (
          <ExcelDownload
            data={filteredclients}
            filename={'ניתוח תוצאות בדיקות דם.csv'}
          ></ExcelDownload>
        ) : null}
        {clientsData && !loading && (
          <TablePagination
            headers={tableHeaders}
            columns={columns}
            rows={filteredclients}
            pagination={true}
            handleRowClick={(id) => {
              const client = filteredclients.find((f) => f.id === id);
              navigate(`/clients/${client.client_uuid}`);
            }}
          ></TablePagination>
        )}
      </div>
    </div>
  );
};

export default AnalysisBloodTests;
